import { Loader2 } from 'lucide-react';

export function LoadingSplash({ message }: { message: string }) {
  return (
    <div className="flex h-full items-center justify-center p-8">
      <div className="flex flex-col items-center gap-3 text-text-secondary">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
        <p className="text-sm">{message}</p>
      </div>
    </div>
  );
}
